import { z } from "zod";
import { scaleIdSchema } from "./scaleSchema";
import { scaleReportIdSchema } from "./scaleReportSchema";

export const scaleReadingSchema = z
  .object({
    id: scaleReportIdSchema,
    scaleId: scaleIdSchema,
    time: z.coerce.date(),
    weight: z.number().nullable(),
    rawWeight: z.number(),
    boardTemperature: z.number(),
    isManualSend: z.boolean(),
  })
  .meta({ id: "ScaleReading" });

export type ScaleReading = z.infer<typeof scaleReadingSchema>;
